import { render, staticRenderFns } from "./HomePlaceholderElement.vue?vue&type=template&id=44ab598c&scoped=true"
import script from "./HomePlaceholderElement.vue?vue&type=script&lang=js"
export * from "./HomePlaceholderElement.vue?vue&type=script&lang=js"
import style0 from "./HomePlaceholderElement.vue?vue&type=style&index=0&id=44ab598c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44ab598c",
  null
  
)

export default component.exports